/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
	Text,
	Tooltip,
	useDisclosure,
	useToast,
} from '@chakra-ui/react';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useStore from '../../../store';

const Q_PROPOSAL = gql`
	query get($proposalNumber: Float!) {
		getCompanySubmissionsProposalByProposalNumber(proposalNumber: $proposalNumber) {
			id
			subject
			no
			createdAt
			assignTo {
				id
				user {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
				createdBy
			}
		}
	}
`;

const ProposalNumberLink = ({ proposalNumber = null, isEditing = false }) => {
	const toast = useToast();
	const confirmModal = useDisclosure();
	const { t } = useTranslation();
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const { push } = useHistory();
	const [loadData, { data }] = useLazyQuery(Q_PROPOSAL);

	useEffect(() => {
		if (proposalNumber) {
			loadData({ variables: { proposalNumber: parseInt(proposalNumber) } });
		}
	}, [proposalNumber]);

	function pushTo() {
		push(`/company-submission-proposal/detail?id=${data?.getCompanySubmissionsProposalByProposalNumber?.id}`);
	}

	return (
		<>
			{data?.getCompanySubmissionsProposalByProposalNumber && (
				<Tooltip label={t('Click to view')}>
					<Text
						cursor="pointer"
						color="#3498DA"
						fontWeight="bold"
						onMouseDown={() => {
							const userIds = data?.getCompanySubmissionsProposalByProposalNumber?.assignTo?.map((assignTo) => assignTo?.user?.id);
							const canView = userIds?.includes(user?.id) || user?.role === 'admin';
							if (canView) {
								if (true === isEditing) {
									confirmModal?.onOpen();
								} else {
									pushTo();
								}
							} else {
								toast({
									title: t('You are not assigned in the proposal'),
									status: 'warning',
									isClosable: true,
									position: 'bottom',
								});
							}
						}}
					>
						<span>{data?.getCompanySubmissionsProposalByProposalNumber?.no}</span>
						<FontAwesomeIcon icon={faExternalLinkAlt} style={{ fontSize: 12, color: '#3498DA', marginLeft: 4, marginBottom: 1 }} />
					</Text>
				</Tooltip>
			)}
			<AlertDialog isOpen={confirmModal?.isOpen} onClose={confirmModal?.onClose}>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							{t('You are editing np or rp')}
						</AlertDialogHeader>
						<AlertDialogBody fontSize="md">{t('Have you saved your current changes?')}</AlertDialogBody>
						<AlertDialogFooter>
							<Button mr={4} onClick={confirmModal?.onClose}>
								{t('Not Yet')}
							</Button>
							<Button
								colorScheme="green"
								onClick={() => {
									confirmModal?.onClose();
									pushTo();
								}}
							>
								{t('Yes, Continue')}
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	);
};

export default ProposalNumberLink;
